<template>
	<div id="hrms75e-detail-tab3" class="panel box-collapse border-color-skin">
    <div class="box-header with-border box-header-collapse collapsed  tab-header" data-toggle="collapse" data-parent="#accordion" href="#tab3">
      <h3 class="box-title">
        <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRMS75EC4']['10'] }}
      </h3>
    </div>
    <div id="tab3" class="panel-collapse collapse tab-detail">
      <div class="panel-body">
        <div class="detail detail-responsive panel-detail-filter">
          <div class="col-md-8">
            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-6 control-label">{{ labels['HRMS75EC4']['20'] }}</label>
                <div class="col-md-6">
                  <div class="form-control readonly-field-color">{{ detail.detail.desc_codcomp }}</div>
                </div>
              </div>
            </form>
            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-6 control-label">{{ labels['HRMS75EC4']['30'] }}</label>
                <div class="col-md-6">
                  <div class="form-control readonly-field-color">{{ detail.detail.desc_codpos }}</div>
                </div>
              </div>
            </form>
          </div>
            <hrms-table  :columns="detailTab3Columns" 
                         :data="detail.table"
                         :maxRowspan="detailTab3MaxRowspan"
                         :searchDisp="false"
                         :selectRowBool="false"
                         :selectBtnDisp="true"
                         :selectEvent="selectEvent"
                         :confirmSelectBtnDisp="false"
                         ref="Tab3" /> 		

        </div>
      </div>
      <div class="modal-footer" >
        <button type="button" class="btn bg-color-skin pull-left" data-dismiss="modal" @click="triggerTab3()"><i class="fa fa-check-circle"></i>{{ labelsButton['approve'] }}</button>
      </div>      
    </div>
  </div>

</template>

<script>
export default {
  name: 'hrms75e-detail-tab3',
  data () {
    return {
      selectedRow: []
    }
  },
  props: [
    'labels',
    'labelsButton',
    'nowLang',
    'detail',
    'detailTab3Columns',
    'detailTab3MaxRowspan',
    'setAddCodcours'
  ],
  methods: {
    triggerTab3 () {
      this.$refs.Tab3.$emit('$selectEventBuiltIn')
    },
    selectEvent (checkedDataRows) {
      this.setAddCodcours(checkedDataRows)
    }
  }
}
</script>


// WEBPACK FOOTER //
// detailTab3.vue?08ba628e